module.exports = __webpack_public_path__ + "media/images/pages/team-94a5ab559b97c6c4a5c416b4a906b210.jpg";